import React from 'react';
import { get } from 'lodash';
import { Text } from '../../common';

const OrderCardCustomer = (props) => {
  const { selectedAddress } = props;
  const { firstName, lastName, phone, email } = get(props, 'customer');
  const { transactions } = get(props, 'paymentData');
  const customerName = `${firstName} ${lastName}`;

  return {
    title: <Text strong text={customerName} />,
    subtitle: () => (
        <div className=''>
            <Text tiny text={phone} />
        </div>
    ),
    extra: <a><Text text='Compras' /> </a>,
    info: [
      { title: <Text tiny text='order_detail.receiver_email' />,
        value: (
            <div style={{ overflow: 'hidden' }}>
                <Text className='truncate-text' tiny text={email} />
            </div>
        ) },
      { title: <Text tiny text='order_detail.receiver_document' />, value: <Text tiny text={get(selectedAddress, 'receiverDocument', 'XX.XXX.XXX-X')} /> },
      { title: <Text tiny text='Dirección' />,
        value: () => (
            <div style={{ overflow: 'hidden' }}>
                <Text tiny text={<>{
                  get(selectedAddress, 'addressLine')}... <a href='#'>Map</a>
                </>} />
            </div>
        ) }
    ],
    extra_info: [
      { title: <Text tiny text='Medio de Pago' />, value: <Text tiny text={get(transactions, '0.payments.0.method')} /> },
      { title: <Text tiny text='Nº tarjeta' />, value: <Text tiny text={get(transactions, '0.payments.0.lastDigits')} /> },
      { title: <Text tiny text='Liberación reserva' />, value: <Text tiny text={get(transactions, '0.payments.0.lastDigits')} /> },
      { title: <Text tiny /> },
      { title: <Text tiny /> }
    ],
    footer: () => {
      return (
          <div className='flex justify-content-center align-items-center'>
              <a><Text text='order_detail.comments' /></a>
          </div>
      );
    }
  };
};

export default OrderCardCustomer;
